// Thai. The key is the English text the app passes to t(); placeholders {x} are kept.
// Technical terms (pole, set, traverse, contour, Fisher K, cone) stay in English, as in DipField.
// test/i18n.test.ts fails when a string in the app has no entry here. GPL-3.0-or-later.
export const TH: Record<string, string> = {
  "(petals beyond the outer ring are clipped)": "(มีกลีบเกินวงนอก ถูกตัดที่ขอบ)",
  "(with a header row)": "(มีหัวตาราง)",
  "+ traverse": "+ traverse",
  "<b>{n}</b> pole": "<b>{n}</b> pole",
  "<b>{n}</b> poles": "<b>{n}</b> pole",
  "<b>{n}</b> set": "<b>{n}</b> set",
  "<b>{n}</b> sets": "<b>{n}</b> set",
  "A negative plunge includes poles across the rim": "plunge ติดลบ = รวม pole ฝั่งตรงข้ามของขอบวง",
  "a pole inside several windows goes to the set whose centre is nearest": "pole ที่อยู่ในหลาย window นับให้ set ที่ศูนย์กลางใกล้ที่สุด",
  "About DipField Suite": "เกี่ยวกับ DipField Suite",
  "Add row": "เพิ่มแถว",
  "all poles": "ทุก pole",
  "All traverses are spot mapping, so no bias correction applies": "ทุก traverse เป็น spot mapping จึงไม่ต้องแก้ bias",
  "Animation off": "ปิดเอฟเฟค",
  "Animation on": "เปิดเอฟเฟค",
  "Animation on / off": "เปิด/ปิดเอฟเฟค",
  "App": "แอป",
  "applied to contours and set statistics": "ใช้กับ contour และสถิติ set แล้ว",
  "Apply Terzaghi weighting": "ใช้ Terzaghi weighting",
  "Apply Terzaghi weighting by scanline": "ใช้ Terzaghi weighting ตาม scanline",
  "Area (√ count)": "พื้นที่ (√ จำนวน)",
  "area scale": "สเกลพื้นที่",
  "At least 10 rows are needed": "ต้องมีข้อมูลอย่างน้อย 10 แถว",
  "At least 2 poles are needed": "ต้องมีอย่างน้อย 2 pole",
  "Auto": "อัตโนมัติ",
  "Bands (DIPS)": "ชั้นสี (DIPS)",
  "Bin": "ช่วง",
  "bm axis (trend/plunge)": "แกน bm (trend/plunge)",
  "Cancel": "ยกเลิก",
  "Centre trend": "ศูนย์กลาง trend",
  "Circle": "วงกลม",
  "Classify sets automatically": "จำแนก set อัตโนมัติ",
  "Classify sets automatically (DSE)": "จำแนก set อัตโนมัติ (DSE)",
  "Click inside a window to select it, drag to move, drag the circle edge to resize, or type values in the set card": "คลิกใน window เพื่อเลือก ลากเพื่อย้าย ลากที่ขอบวงกลมเพื่อปรับรัศมี หรือพิมพ์ค่าในการ์ดของ set",
  "Close": "ปิด",
  "Column {name}": "คอลัมน์ {name}",
  "Column {n}": "คอลัมน์ {n}",
  "Computing…": "กำลังคำนวณ…",
  "Cone 95%": "Cone 95%",
  "Cone radius (°)": "รัศมี cone (°)",
  "Contour style": "รูปแบบ contour",
  "converted from {app}": "แปลงมาจาก {app}",
  "Could not open {name}: {why}": "เปิด {name} ไม่ได้: {why}",
  "Could not read the .xlsx file: {e}": "อ่านไฟล์ xlsx ไม่ได้: {e}",
  "Count": "จำนวน",
  "Counting circle (% of the hemisphere area)": "Counting circle (% ของพื้นที่ซีกโลก)",
  "Curved": "โค้ง",
  "Data": "ข้อมูล",
  "Data & sets": "ข้อมูลและ set",
  "Data format": "รูปแบบข้อมูล",
  "Delete all": "ลบทั้งหมด",
  "Delete all sets": "ลบทุก set",
  "Delete project": "ลบโปรเจกต์",
  "Delete row": "ลบแถว",
  "Delete row {n}": "ลบแถว {n}",
  "Delete set": "ลบ set",
  "Delete traverse": "ลบ traverse",
  "Delete {name}": "ลบ {name}",
  "Deleted {name}": "ลบ {name} แล้ว",
  "Deleted {n} row and every set": "ลบข้อมูล {n} แถวและ set ทั้งหมดแล้ว",
  "Deleted {n} rows and every set": "ลบข้อมูล {n} แถวและ set ทั้งหมดแล้ว",
  "Deleted {n} set": "ลบ {n} set แล้ว",
  "Deleted {n} sets": "ลบ {n} set แล้ว",
  "Density (% per 1% area)": "ความหนาแน่น (% ต่อพื้นที่ 1%)",
  "Density method": "วิธีคำนวณความหนาแน่น",
  "density {d}%": "ความหนาแน่น {d}%",
  "Dip direction rosette": "Dip direction rosette",
  "DipField Suite · GPL-3.0 · Automatic set classification uses DSE: Riquelme et al. (2014) Computers & Geosciences 68:38–52, ported from DSEpy 1.0.1 (Riquelme, Tomás & Abellán, GPL-3.0)": "DipField Suite · GPL-3.0 · การจำแนก set อัตโนมัติใช้วิธี DSE: Riquelme et al. (2014) Computers & Geosciences 68:38–52, port จาก DSEpy 1.0.1 (Riquelme, Tomás & Abellán, GPL-3.0)",
  "Discontinuity data": "ข้อมูลรอยแตก",
  "Discontinuity data, joint sets and failure-mode assessment for rock slopes and tunnels.": "ข้อมูลรอยแตก joint set และการประเมินโหมดการพังทลายของลาดหินและอุโมงค์",
  "Display": "แสดงผล",
  "Drag from one corner of the trend/plunge range to the other; drag past the rim to include poles on the far side": "ลากจากมุมหนึ่งไปอีกมุมของช่วง trend/plunge ลากเลยขอบวงเพื่อรวม pole ฝั่งตรงข้าม",
  "Drop a CSV / Excel / project file here": "วางไฟล์ CSV / Excel / โปรเจกต์ ที่นี่",
  "Each table row can be assigned a traverse, or import one from a Traverse column in the file": "แต่ละแถวในตารางกำหนด traverse ได้ หรือนำเข้าจากคอลัมน์ Traverse ในไฟล์",
  "Edit": "แก้ไข",
  "Empty = the global value": "เว้นว่าง = ใช้ค่ารวม",
  "Equal angle": "Equal angle",
  "Equal angle (DSEpy default)": "Equal angle (ค่าเดิมของ DSEpy)",
  "Equal area": "Equal area",
  "Equal area (recommended)": "Equal area (แนะนำ)",
  "Every row was read": "ทุกแถวอ่านได้",
  "Every saved project and export records these versions, so a result can be traced to the engine that produced it.": "ทุกโปรเจกต์ที่บันทึกและทุกไฟล์ที่ส่งออกจะบันทึกเวอร์ชันเหล่านี้ไว้ เพื่อให้ตรวจย้อนได้ว่าผลมาจาก engine รุ่นใด",
  "Export PNG": "ส่งออก PNG",
  "Export sets (JSON)": "ส่งออก set (JSON)",
  "Export SVG": "ส่งออก SVG",
  "Export table (CSV)": "ส่งออกตาราง (CSV)",
  "File": "ไฟล์",
  "Finds the pole-density peaks and builds circular set windows, following the DSE method of Riquelme et al. (2014); ported from DSEpy 1.0.1 and matching its results.": "หา peak ของความหนาแน่น pole แล้วสร้าง set window แบบวงกลมให้ ตามวิธี DSE ของ Riquelme et al. (2014) port จาก DSEpy 1.0.1 ผลตรงกับ DSEpy ตัวจริง",
  "Fixed": "กำหนดเอง",
  "Found {n} set · review and adjust the windows with the Edit tool": "พบ {n} set · ตรวจและแก้ไข window ต่อได้ด้วยเครื่องมือ \"แก้ไข\"",
  "Found {n} sets · review and adjust the windows with the Edit tool": "พบ {n} set · ตรวจและแก้ไข window ต่อได้ด้วยเครื่องมือ \"แก้ไข\"",
  "Free software under the GNU General Public License, version 3 or later. Fonts: Barlow and Anuphan (SIL Open Font License); 3D views: three.js (MIT).": "ซอฟต์แวร์เสรีภายใต้ GNU General Public License รุ่น 3 หรือใหม่กว่า ฟอนต์ Barlow และ Anuphan (SIL Open Font License) ภาพ 3 มิติใช้ three.js (MIT)",
  "Third-party notices": "ประกาศสัญญาอนุญาตของส่วนประกอบภายนอก",
  "Freehand": "อิสระ",
  "Freehand window — drag on the net to move it": "window แบบอิสระ ลากบนตาข่ายเพื่อย้าย",
  "Friction angle of {name}": "มุมเสียดทานของ {name}",
  "Global best fit (bm)": "Global best fit (bm)",
  "Global best fit, bm": "Global best fit, bm",
  "Global mean (gm)": "Global mean (gm)",
  "Global mean, gm": "Global mean, gm",
  "gm is the vector sum of all poles — suited to a single, not too steep cluster. bm is the plane that best fits the trend of the poles — used for the axis of a girdle, e.g. a fold axis.": "gm คือผลรวมเวกเตอร์ของ pole ทั้งหมด เหมาะกับข้อมูลที่เป็นกลุ่มเดียวและไม่ชันมาก ส่วน bm คือระนาบที่ลากผ่านแนว pole ได้ดีที่สุด ใช้หาแกนของ girdle เช่นแกนชั้นหินคดโค้ง",
  "Hemisphere": "ซีกโลก",
  "Hover the net to read values": "ชี้บนตาข่ายเพื่ออ่านค่า",
  "Import": "นำเข้า",
  "Import CSV / Excel": "นำเข้า CSV / Excel",
  "Import {n} rows": "นำเข้า {n} แถว",
  "Imported {n} rows · the data panel is hidden; press Data to open it": "นำเข้า {n} แถวแล้ว · ซ่อนแถบข้อมูลให้ กดปุ่ม \"ข้อมูล\" เพื่อเปิด",
  "it is not a DipField Suite, DipField or DipField Slope project": "ไม่ใช่ไฟล์โปรเจกต์ของ DipField Suite, DipField หรือ DipField Slope",
  "toppling now uses the contact rules, so a toppling FS can be lower than DipField Slope gave": "การล้มคว่ำใช้กฎการสัมผัสแล้ว FS ของการล้มคว่ำจึงอาจต่ำกว่าที่ DipField Slope เคยให้",
  "it is not a JSON file": "ไม่ใช่ไฟล์ JSON",
  "it states units other than kN, kPa and m": "ไฟล์ระบุหน่วยอื่นที่ไม่ใช่ kN, kPa และ m",
  "it used an older density setting and now uses Fisher (DIPS), so values may differ slightly from what was saved": "ไฟล์ใช้การตั้งค่าความหนาแน่นแบบเดิม เปลี่ยนเป็น Fisher (DIPS) แล้ว ค่าอาจต่างจากที่บันทึกไว้เล็กน้อย",
  "it was saved by a newer version of DipField Suite": "บันทึกจาก DipField Suite รุ่นที่ใหม่กว่านี้",
  "Joint sets": "Joint sets",
  "Kind of traverse {name}": "ชนิด traverse {name}",
  "largest bin {a}–{b}° ({p}%)": "ช่วงที่มากที่สุด {a}–{b}° ({p}%)",
  "Largest weight {w} (capped at {cap} by the minimum angle {a}°)": "น้ำหนักสูงสุด {w} (จำกัดที่ {cap} จากมุมต่ำสุด {a}°)",
  "Length (count)": "ความยาว (จำนวน)",
  "Linear scanline / borehole": "Linear scanline / borehole",
  "Lower": "ล่าง",
  "lower hemisphere": "ซีกโลกล่าง",
  "Main view": "มุมมองหลัก",
  "max": "สูงสุด",
  "max {m}% · {method} · counting circle {c}%": "สูงสุด {m}% · {method} · counting circle {c}%",
  "Maximum sets": "จำนวน set สูงสุด",
  "Mean": "ค่าเฉลี่ย",
  "Mean plane": "ระนาบเฉลี่ย",
  "mean {m}° (R = {r})": "ค่าเฉลี่ย {m}° (R = {r})",
  "Minimum bias angle (°)": "มุม bias ต่ำสุด (องศา)",
  "Minimum peak (%)": "peak ขั้นต่ำ (%)",
  "Minimum separation (°)": "มุมห่างขั้นต่ำ (°)",
  "Modules": "โมดูล",
  "Name of the open project": "ชื่อโปรเจกต์ที่เปิดอยู่",
  "Net grid": "เส้นตาข่าย",
  "New project": "โปรเจกต์ใหม่",
  "Next": "ถัดไป",
  "No cluster stands out enough; try a lower minimum peak": "ไม่พบกลุ่มที่เด่นพอ ลองลด peak ขั้นต่ำ",
  "No data found in {name}": "ไม่พบข้อมูลใน {name}",
  "No data yet": "ยังไม่มีข้อมูล",
  "No data yet — <b>import a CSV / Excel file</b> or press <b>Use sample data</b> in the left panel": "ยังไม่มีข้อมูล — <b>นำเข้าไฟล์ CSV / Excel</b> หรือกด <b>ใช้ข้อมูลตัวอย่าง</b> ที่แถบซ้าย",
  "No joint sets yet": "ยังไม่มี joint set",
  "No rows yet — import a file, paste data, or press “Add row”": "ยังไม่มีแถว — นำเข้าไฟล์ วางข้อมูล หรือกด “เพิ่มแถว”",
  "None": "ไม่แสดง",
  "Not used": "ไม่ใช้",
  "Nothing to export yet": "ยังไม่มีอะไรให้ส่งออก",
  "On the stereonet": "ซ้อนบน stereonet",
  "Once sets are defined you get mean planes, Fisher K and the 95% cone; the Slope and Tunnel modules use them.": "แบ่ง set แล้วจะได้ระนาบเฉลี่ย Fisher K และ cone 95% ซึ่งโมดูลลาดหินและอุโมงค์จะใช้ต่อ",
  "Open": "เปิด",
  "open": "เปิดอยู่",
  "Open project file…": "เปิดไฟล์โปรเจกต์…",
  "Opened {name}": "เปิด {name} แล้ว",
  "Outer ring": "วงนอก",
  "outer ring {o}%": "วงนอก {o}%",
  "Overlay the rosette on the stereonet": "แสดง rosette ซ้อนบน stereonet",
  "Paste data from a table": "วางข้อมูลจากตาราง",
  "pasted text": "ข้อความที่วาง",
  "Percent of the total at the outer ring": "ร้อยละของทั้งหมดที่วงนอก",
  "pick <b>Circle</b>, <b>Curved</b> or <b>Freehand</b> and draw around a cluster of poles on the net": "เลือกเครื่องมือ <b>วงกลม</b> <b>โค้ง</b> หรือ <b>อิสระ</b> แล้ววาดรอบกลุ่ม pole บนตาข่าย",
  "Pick a tool and draw on the net; press Esc to stop": "เลือกเครื่องมือแล้ววาดบนตาข่าย กด Esc เพื่อหยุด",
  "Planar (rock face)": "Planar (หน้าหิน)",
  "plunge": "plunge",
  "Plunge min": "Plunge ต่ำสุด",
  "Pole density (% per 1% area)": "ความหนาแน่นของ pole (% ต่อพื้นที่ 1%)",
  "Pole size": "ขนาดจุด pole",
  "Pole table": "ตาราง pole",
  "Poles": "จำนวน pole",
  "Presentation mode": "โหมดนำเสนอ",
  "Presentation mode (P)": "โหมดนำเสนอ (P)",
  "Presentation mode off": "ออกจากโหมดนำเสนอ",
  "Presentation mode · press P to leave": "โหมดนำเสนอ · กด P เพื่อออก",
  "Press <b>Classify sets automatically (DSE)</b> above and review the result, or": "กด <b>จำแนก set อัตโนมัติ (DSE)</b> ด้านบน แล้วตรวจผล หรือ",
  "Press and draw around a group of poles; release when done": "กดค้างแล้ววาดรอบกลุ่ม pole ปล่อยเมื่อวาดครบ",
  "Press at the set centre and drag outwards to set the radius; drag past the rim if the set straddles it": "กดที่ศูนย์กลาง set แล้วลากออกเพื่อกำหนดรัศมี ลากเลยขอบวงได้ถ้า set ข้ามขอบ",
  "Previous": "ก่อนหน้า",
  "Project": "โปรเจกต์",
  "Project file": "ไฟล์โปรเจกต์",
  "Project orientation format": "รูปแบบทิศทางของโปรเจกต์",
  "Projection": "Projection",
  "Projection for the peak search": "Projection ที่ใช้หา peak",
  "Projects": "โปรเจกต์",
  "Projects are kept in this browser on this device. Save a project file to move it or back it up.": "โปรเจกต์เก็บไว้ในเบราว์เซอร์ของเครื่องนี้ บันทึกเป็นไฟล์โปรเจกต์เพื่อย้ายเครื่องหรือสำรองไว้",
  "Projects…": "โปรเจกต์…",
  "Quantity column (optional)": "คอลัมน์จำนวน (ถ้ามี)",
  "Radius (°)": "รัศมี (°)",
  "Read pasted data": "อ่านข้อมูลที่วาง",
  "Redo": "ทำซ้ำ",
  "Redo (Ctrl+Y)": "ทำซ้ำ (Ctrl+Y)",
  "Replace existing data": "แทนที่ข้อมูลเดิม",
  "Report": "รายงาน",
  "Rosette": "Rosette",
  "Row {n}": "แถว {n}",
  "row {n}": "แถว {n}",
  "row {r}: measurements, invalid dip/dip direction": "แถว {r}: measurements ค่า dip/dip direction ไม่ถูกต้อง",
  "row {r}: measurements, {id} is not in the scanlines sheet (counted as spot)": "แถว {r}: measurements ไม่พบ {id} ในชีต scanlines (นับเป็น spot)",
  "row {r}: not a number": "แถว {r}: ไม่ใช่ตัวเลข",
  "row {r}: scanlines, invalid trend/plunge for {id}": "แถว {r}: scanlines ค่า trend/plunge ของ {id} ไม่ถูกต้อง",
  "row {r}: {a}, {b} is out of range for this format": "แถว {r}: ค่า {a}, {b} อยู่นอกช่วงของรูปแบบนี้",
  "rows {a}–{b} of {n}": "แถว {a}–{b} จาก {n}",
  "Save project file": "บันทึกไฟล์โปรเจกต์",
  "Scale": "สเกล",
  "scanline template": "แบบฟอร์ม scanline",
  "Set": "ชุด",
  "Set name": "ชื่อ set",
  "Set the minimum peak to 0 and choose Equal angle to reproduce the original DSEpy result. A new classification replaces all existing sets (undo is available).": "ตั้ง peak ขั้นต่ำเป็น 0 และเลือก Equal angle เพื่อให้ได้ผลแบบ DSEpy ต้นฉบับ การจำแนกใหม่จะแทนที่ set เดิมทั้งหมด (กดย้อนกลับได้)",
  "Set window tools": "เครื่องมือวาด set window",
  "Sets, traverses and display": "set, traverse และการแสดงผล",
  "Sheet": "ชีต",
  "sheet {name}": "ชีต {name}",
  "Show density contours": "แสดง contour ความหนาแน่น",
  "Show each set's mean plane": "แสดงระนาบเฉลี่ยของแต่ละ set",
  "Show or hide the data panel": "ซ่อน/แสดงแถบข้อมูล",
  "Show or hide the tools panel": "ซ่อน/แสดงแถบเครื่องมือ",
  "Show poles": "แสดง pole",
  "Show the 95% cone of confidence": "แสดง cone of confidence 95%",
  "Slope": "ลาดหิน",
  "Smooth": "ไล่สีต่อเนื่อง",
  "Spot mapping (no bias correction)": "Spot mapping (ไม่แก้ bias)",
  "Stereonet of poles": "Stereonet ของ pole",
  "Strike (left) / Dip": "Strike (ซ้าย) / Dip",
  "Strike (right) / Dip": "Strike (ขวา) / Dip",
  "Strike rosette": "Strike rosette",
  "Terzaghi weighted": "ถ่วงน้ำหนัก Terzaghi",
  "The table, net readouts and statistics use this format. Edit numbers directly in the table.": "ตาราง ค่าที่อ่านบนตาข่าย และสถิติ แสดงในรูปแบบนี้ แก้ตัวเลขในตารางได้โดยตรง",
  "This browser does not keep projects (private window?): save a project file before closing.": "เบราว์เซอร์นี้ไม่เก็บโปรเจกต์ (อาจเป็นหน้าต่างส่วนตัว) บันทึกเป็นไฟล์โปรเจกต์ก่อนปิด",
  "This point is the pole of plane {plane} ({fmt}) · pole trend/plunge {tp}": "ตำแหน่งนี้เป็น pole ของระนาบ {plane} ({fmt}) · pole trend/plunge {tp}",
  "to": "ถึง",
  "Tools": "เครื่องมือ",
  "Trav.": "Trav.",
  "Traverse column (optional)": "คอลัมน์ Traverse (ถ้ามี)",
  "Traverse name": "ชื่อ traverse",
  "Traverses": "Traverse",
  "Traverses & Terzaghi": "Traverse และ Terzaghi",
  "Trend from": "Trend จาก",
  "Tunnel": "อุโมงค์",
  "Unassigned (spot)": "ไม่ระบุ (spot)",
  "Undo": "ย้อนกลับ",
  "Undo (Ctrl+Z)": "ย้อนกลับ (Ctrl+Z)",
  "Untitled project": "โปรเจกต์ใหม่",
  "Upper": "บน",
  "upper hemisphere": "ซีกโลกบน",
  "Use sample data": "ใช้ข้อมูลตัวอย่าง",
  "Use Terzaghi weighting when it is on": "ใช้ Terzaghi weighting ถ้าเปิดอยู่",
  "Variability 1σ": "Variability 1σ",
  "version {v}": "รุ่น {v}",
  "View": "ดูค่า",
  "weight sum {w}": "น้ำหนักรวม {w}",
  "Whole data set": "ระนาบรวมของข้อมูลทั้งชุด",
  "{method}, counting circle {c}%, max {m}%": "{method}, counting circle {c}%, สูงสุด {m}%",
  "{m} m in total": "ยาวรวม {m} ม.",
  "{n} planes (dip {a}–{b}°) · bin {w}°": "{n} ระนาบ (dip {a}–{b}°) · ช่วง {w}°",
  "{n} pole": "{n} pole",
  "{n} pole is in no set": "ไม่อยู่ใน set ใด {n} pole",
  "{n} poles": "{n} pole",
  "{n} poles are in no set": "ไม่อยู่ใน set ใด {n} pole",
  "{n} poles · {proj}": "{n} pole · {proj}",
  "{n} row": "{n} แถว",
  "{n} rows": "{n} แถว",
  "{n} rows skipped or flagged:": "ข้ามหรือเตือน {n} แถว:",
  "{n} rows skipped:": "ข้ามไป {n} แถว:",
  "{n} set": "{n} set",
  "{n} sets": "{n} set",
  "{s} scanlines{len} and {n} measurements. A linear traverse is created automatically for each line from its trend/plunge.": "พบ scanline {s} เส้น{len} และรอยแตก {n} แถว ระบบจะสร้าง traverse แบบ linear ตาม trend/plunge ของแต่ละเส้นให้อัตโนมัติ",
  "φ of the set": "φ ของ set",
};
